import { useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Header from '@/components/outest-layout/header';
import ProviderCrumb from '@/components/outest-layout/provider-crumb';
import WithoutHeader from '@/components/outest-layout-without-header';
import BabelPage from '../pages/babel';
import goto, { GOTO_TYPE } from '../utils/goto';
import PromotionTools from '../pages/promotion-tools';
import BaiChuan from '../pages/baichuan';
import logout from '../utils/logout';
import TBTools from '../pages/tb-tool';
import globalcmsRoutes from './globalcms';
import zhongchouCmsRoutes from './zhongchouCmsRoutes';
import SeckillCMS from '../pages/seckill-cms';
import PUSHInnerMessage from '../pages/PUSH';
import sanchaoCmsRoutes from './sanchaoCmsRoutes';

function NoHeaderView() {
  const [crumbs, updateCrumbs] = useState([]);
  return (
    <ProviderCrumb.Provider value={{ crumbs, updateCrumbs }}>
      <Header toIndex={() => goto('/', GOTO_TYPE.FORCEUPDATE)} logout={logout} />
      <Switch>
        <Route path="/materials/babel" component={BabelPage} />
        <Route path="/materials/promotion-tools" component={PromotionTools} />
        <Route path="/materials/tb-tools" component={TBTools} />
        {/* <Route path="/cms-global/:channelId/:menuId/*" component={CmsGlobal} /> */}
        <Route path="/materials/bc" component={BaiChuan} />
        <Route path="/materials/seckill-cms" component={SeckillCMS} />
        <Route path="/materials/PUSH-inner-message" component={PUSHInnerMessage} />
        {globalcmsRoutes}

        {/* 三超CMS */}
        {sanchaoCmsRoutes}
        {/* 众筹CMS */}
        {zhongchouCmsRoutes}
        <Route
          path="*"
          component={() => {
            window.location.href = '/404';
            return null;
          }}
        />
      </Switch>
    </ProviderCrumb.Provider>
  );
}

export default function Routes() {
  return (
    <Switch>
      <Route
        path="/materials/withoutHeader"
        component={() => (
          <div style={{ display: 'flex' }}>
            <WithoutHeader />
            <Switch>
              <Route exact path="/materials/withoutHeader/bc" component={BaiChuan} />
              <Route
                path="*"
                component={() => {
                  window.location.href = '/404';
                  return null;
                }}
              />
            </Switch>
          </div>
        )}
      ></Route>
      <Route path="/materials/*" component={NoHeaderView}></Route>
    </Switch>
  );
}
